import { GridItem, gridConfig } from '@tvg/fuse-design/responsive-grid';
import { TypographyComponent as Typography } from '@tvg/fuse-design/typography-element';
import React from 'react';
import styled from 'styled-components';
import FacetItemList from './FacetItemList';

const FilterColumnStyled = styled(GridItem)`
  && {
    overflow-wrap: anywhere;
    word-break: break-word;

    @media screen and (max-width: ${gridConfig.m.maxWidth}) {
      display: none;
    }
    @media screen and (min-width: ${gridConfig.l.minWidth}) {
      margin-right: var(--spacing-space16);
    }
  }
`;

const TypographyStyled = styled(Typography)`
  margin-bottom: var(--spacing-space16);
`;

export function Facet() {
  return (
    <FilterColumnStyled l="3" className="grid-item desktop-filters">
      <div className="accordion-container accordion-facet-container" data-testid="accordion-facet-container">
        <TypographyStyled className="facet-heading" data-testid="test-facet-heading" type="heading" size="4" tag="h2">
          Filter
        </TypographyStyled>
        <FacetItemList />
      </div>
    </FilterColumnStyled>
  );
}
